<template>
  <div
    v-for="(attribute, i) in availableAttributes"
    :key="'attribute_' + i"
    class="not-last:mb-20"
  >
    <h3 class="text-md font-semibold mb-5">{{ attribute.label }}</h3>
    <ul class="flex flex-wrap gap-20">
      <li v-for="value in attribute.values" :key="value.variation?.id">
        <NuxtLink
          v-if="value.variation?.url?.path"
          :to="value.variation.url.path"
          :class="{
            'font-semibold text-green underline underline-offset-4':
              value.variation.id === activeVariationId,
          }"
        >
          {{ value.label }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type {
  CommercePreparedAttributeFragment,
  CommerceProductPageVariationItemFragment,
} from '#graphql-operations'

const props = defineProps<{
  attributes?: CommercePreparedAttributeFragment[]
  activeVariationId?: string
  allVariations: CommerceProductPageVariationItemFragment[]
}>()

const ATTRIBUTE_ORDER = [
  'attribute_target_group',
  'attribute_language',
  'attribute_course_module',
]

const availableAttributes = computed<CommercePreparedAttributeFragment[]>(
  () => {
    const filtered = props.attributes?.filter((v) => !!v.values?.length) || []
    return [...filtered].sort((a, b) => {
      const indexA = ATTRIBUTE_ORDER.indexOf(a.fieldName || '')
      const indexB = ATTRIBUTE_ORDER.indexOf(b.fieldName || '')
      return (
        (indexA === -1 ? Infinity : indexA) -
        (indexB === -1 ? Infinity : indexB)
      )
    })
  },
)
</script>
